import { render, staticRenderFns } from "./deposit.vue?vue&type=template&id=60290a18&"
import script from "./deposit.vue?vue&type=script&lang=js&"
export * from "./deposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports